import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import Router from './components/router/router.component';
import './index.scss';

ReactDOM.render(
    <BrowserRouter>
        <Router/>
    </BrowserRouter>,
  document.getElementById('root')
);
